import type { TypedDocumentNode, ApolloLink } from '@apollo/client';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

// eslint-disable-next-line import-x/named
import type { updateUserProfileInput } from '#src/__generated__/globalTypes.ts';
import { useSnackNotificationContext } from '#src/contexts/snackNotification/index.ts';

import type {
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables,
} from './__generated__/useUpdateUserProfile.graphql.ts';

const UPDATE_USER_PROFILE_MUTATION = gql`
  mutation UpdateUserProfileMutation($input: updateUserProfileInput!) {
    updateUserProfile(input: $input) {
      userProfile {
        id
        status
        pictureUrl
        user {
          slug
          nickname
          pictureUrl(derivative: "avatar")
        }
        marketplacePreferences(sports: [FOOTBALL, NBA, BASEBALL]) {
          sport
          preferences {
            name
            value
          }
        }
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables
>;

export const useUpdateUserProfile = () => {
  const [mutate] = useMutation(UPDATE_USER_PROFILE_MUTATION);
  const { showNotification } = useSnackNotificationContext();

  return async (input: updateUserProfileInput) => {
    const { data, errors } = (await mutate({
      variables: {
        input,
      },
    })) as ApolloLink.Result<UpdateUserProfileMutation>;

    if (data) {
      return data.updateUserProfile!;
    }
    showNotification('errors', {
      errors: errors?.map(({ message }) => message),
    });
    return null;
  };
};
